module.exports = __webpack_public_path__ + "static/logo-f24d74594013d000e778aa701ae1eb39.jpg";